import { queryOptions } from '@tanstack/react-query';
import { KeywordsRankingsRequest, getKeywordsRankings } from '~/apis/mercari/get-keywords-rankings';

export const keywordsRankingsOptions = (params: KeywordsRankingsRequest) =>
  queryOptions({
    queryKey: ['search', 'getRankedKeywords', { ...params }],
    queryFn: () => getKeywordsRankings(params),
    select: (data) => data.data,
    placeholderData: (prevData) => prevData,
    staleTime: 1000 * 3,
  });
